export default __webpack_public_path__ + "static/05.02-cf7d7cc218e01f36bddcc39e3d6c3e7e.png";